import React from 'react';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <span>&copy; {currentYear} legislacao.online · Brasília · São Paulo</span>
        <span className="footer-credits">Dados oficiais: Câmara dos Deputados · Senado Federal</span>
      </div>
    </footer>
  );
}
